// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { StatisticsForCountryResponseDto } from '../models';
// @ts-ignore
import type { StatisticsItemTypeDto } from '../models';
// @ts-ignore
import type { StatisticsPerTypeResponseDto } from '../models';
/**
 * StatisticsRestApi - axios parameter creator
 */
export const StatisticsRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Statistics per type
         * @param {StatisticsItemTypeDto} type 
         * @param {Array<number>} itemsIds 
         * @param {number} page 
         * @param {number} size 
         * @param {number} [countryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics: async (type: StatisticsItemTypeDto, itemsIds: Array<number>, page: number, size: number, countryId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getStatistics', 'type', type)
            // verify required parameter 'itemsIds' is not null or undefined
            assertParamExists('getStatistics', 'itemsIds', itemsIds)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getStatistics', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getStatistics', 'size', size)
            const localVarPath = `/api/v1/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (itemsIds) {
                localVarQueryParameter['itemsIds'] = itemsIds.join(COLLECTION_FORMATS.csv);
            }

            if (countryId !== undefined) {
                localVarQueryParameter['countryId'] = countryId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Statistics per country
         * @param {number} countryId 
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsForCountry: async (countryId: number, page: number, size: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryId' is not null or undefined
            assertParamExists('getStatisticsForCountry', 'countryId', countryId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getStatisticsForCountry', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getStatisticsForCountry', 'size', size)
            const localVarPath = `/api/v1/statistics/{countryId}`
                .replace('{countryId}', encodeURIComponent(String(countryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsRestApi - functional programming interface
 */
export const StatisticsRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Statistics per type
         * @param {StatisticsItemTypeDto} type 
         * @param {Array<number>} itemsIds 
         * @param {number} page 
         * @param {number} size 
         * @param {number} [countryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistics(type: StatisticsItemTypeDto, itemsIds: Array<number>, page: number, size: number, countryId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsPerTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistics(type, itemsIds, page, size, countryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsRestApi.getStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Statistics per country
         * @param {number} countryId 
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatisticsForCountry(countryId: number, page: number, size: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsForCountryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatisticsForCountry(countryId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsRestApi.getStatisticsForCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsRestApi - factory interface
 */
export const StatisticsRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Statistics per type
         * @param {StatisticsItemTypeDto} type 
         * @param {Array<number>} itemsIds 
         * @param {number} page 
         * @param {number} size 
         * @param {number} [countryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics(type: StatisticsItemTypeDto, itemsIds: Array<number>, page: number, size: number, countryId?: number, options?: RawAxiosRequestConfig): AxiosPromise<StatisticsPerTypeResponseDto> {
            return localVarFp.getStatistics(type, itemsIds, page, size, countryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Statistics per country
         * @param {number} countryId 
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsForCountry(countryId: number, page: number, size: number, options?: RawAxiosRequestConfig): AxiosPromise<StatisticsForCountryResponseDto> {
            return localVarFp.getStatisticsForCountry(countryId, page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsRestApi - interface
 */
export interface StatisticsRestApiInterface {
    /**
     * 
     * @summary Statistics per type
     * @param {StatisticsItemTypeDto} type 
     * @param {Array<number>} itemsIds 
     * @param {number} page 
     * @param {number} size 
     * @param {number} [countryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatistics(type: StatisticsItemTypeDto, itemsIds: Array<number>, page: number, size: number, countryId?: number, options?: RawAxiosRequestConfig): AxiosPromise<StatisticsPerTypeResponseDto>;

    /**
     * 
     * @summary Statistics per country
     * @param {number} countryId 
     * @param {number} page 
     * @param {number} size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatisticsForCountry(countryId: number, page: number, size: number, options?: RawAxiosRequestConfig): AxiosPromise<StatisticsForCountryResponseDto>;

}

/**
 * StatisticsRestApi - object-oriented interface
 */
export class StatisticsRestApi extends BaseAPI implements StatisticsRestApiInterface {
    /**
     * 
     * @summary Statistics per type
     * @param {StatisticsItemTypeDto} type 
     * @param {Array<number>} itemsIds 
     * @param {number} page 
     * @param {number} size 
     * @param {number} [countryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStatistics(type: StatisticsItemTypeDto, itemsIds: Array<number>, page: number, size: number, countryId?: number, options?: RawAxiosRequestConfig) {
        return StatisticsRestApiFp(this.configuration).getStatistics(type, itemsIds, page, size, countryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Statistics per country
     * @param {number} countryId 
     * @param {number} page 
     * @param {number} size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStatisticsForCountry(countryId: number, page: number, size: number, options?: RawAxiosRequestConfig) {
        return StatisticsRestApiFp(this.configuration).getStatisticsForCountry(countryId, page, size, options).then((request) => request(this.axios, this.basePath));
    }
}

